import React from "react";
import { Container } from "@prestosports/commons-ui";
import Box from "@material-ui/core/Box";
import GameEventDetails from "../components/GameEventDetails";
import NavigationTabPanel from "../../season/components/NavigationTabPanel";
import GameHeader from "../components/GameHeader";
import commonStyles from "../../common/styles/Common.styles";
import EventSettings from "../../common/components/EventSettings";

const GameInfoContainer = () => {
	const commonClasses = commonStyles();

	const getTabItems = () => {
		const tabItems = [];

		tabItems.push({
			label: "Event Details",
			tab: "details",
			component: <GameEventDetails />
		});

		tabItems.push({
			label: "Event Settings",
			tab: "settings",
			component: <EventSettings />
		});

		return tabItems;
	};

	return (
		<>
			<GameHeader
				title="Event Information"
				description="Update and review the event information below."
			/>
			<Box className={commonClasses.infoContainer}>
				<Container fullHeight>
					<NavigationTabPanel items={getTabItems()} />
				</Container>
			</Box>
		</>
	);
};

export default GameInfoContainer;
